import { Module } from '@nestjs/common'
import { AuthController } from './auth.controller'
import { AuthEmailService, AuthService } from './services'

@Module({
	controllers: [AuthController],
	providers: [AuthService, AuthEmailService],
})
export class AuthModule {}
